import { ModalSeeker, GridSeeker, IconSeekers, useUser } from 'ui-seeker/core'
import * as React from 'react'
import i18n from 'i18n'
import { useEffect, useState } from 'react'
import { SelectUser } from '../commonFilters/components'
import { FEATURES, USER_ROLE } from 'app/@common/constants'
import { getAppUserData } from "app/@utils"
import {useContextSelector} from "use-context-selector";
import {AppDatesContext} from "../../providers";

export default function AppNoDataModal({ type='hotels', features=FEATURES.HOTELS }) {

    const { uidSlave, role, features: appFeatures } = getAppUserData()
	const isUserMaster = role === USER_ROLE.MASTER
	const userFeatures = appFeatures?.[uidSlave]
	const [openModalNoData, setOpenModalNoData] = useState(false)
	const [mainUser, setMainUser] = useState(parseInt(uidSlave))
	const { userData } = useUser()
	const numMonths = useContextSelector(AppDatesContext, ({ state }) => state.numMonths)

	useEffect(() => {
		if ((numMonths === 1 && isUserMaster) || (!userFeatures?.includes(features) && role !== USER_ROLE.ADMIN)) setOpenModalNoData(true)
		else setOpenModalNoData(false)
		// eslint-disable-next-line
	}, [numMonths])

	const modalNoData = {
		isOpen: openModalNoData,
		controller: setOpenModalNoData,
		okBtn: false,
		cancelBtn: false,
		backdropClassName: 'loading-modal',
		backdrop: 'static'
	}

	return  <ModalSeeker {...modalNoData}>
		<GridSeeker spacing={2} container>
			<GridSeeker size={12} style={{ display: 'flex', alignItems: 'center' }}>
				<IconSeekers icon='exclamation-triangle' iconType='fontAwesome' iconWeight='fas' className="mr-12" style={{ color: '#ffb74d', fontSize: '32px' }} />
				<span>{i18n.t('common:misc.noDataForActiveUser')}</span>
			</GridSeeker>
			<GridSeeker size={12}>
				<SelectUser
					value={mainUser || parseInt(userData.userID)}
					mainSection={true}
					onChange={setMainUser}
					type={type}
					feature={features}
				/>
			</GridSeeker>
		</GridSeeker>
	</ModalSeeker>
}